export default __webpack_public_path__ + "static/media/illustration-work-2-m@2x.352a2351.webp";